import React, { Fragment } from "react";

import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";

// Material ui icons
import CachedIcon from "@mui/icons-material/Cached";

const parameters = ({ data }) => {
  const {
    inputParameters,
    handleParameterChange,
    setInputParameters,
  } = data;

  return (
    <Fragment>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Parameters
      </Typography>
      <TextField
        fullWidth
        value={inputParameters.awsProfile}
        helperText="Your AWS profile"
        label="AWS profile"
        onChange={handleParameterChange("awsProfile")}
        sx={{ mt: 2, mb: 2 }}
      />
      <TextField
        fullWidth
        value={inputParameters.projectName}
        helperText="Project name lowercase"
        label="Project name"
        onChange={handleParameterChange("projectName")}
        sx={{  mb: 2 }}
      />
      <TextField
        fullWidth
        value={inputParameters.projectShortName}
        helperText="Project shortname in lowercase"
        label="Project shortname"
        onChange={handleParameterChange("projectShortName")}
        sx={{ mb: 2 }}
      />
      <TextField
        fullWidth
        value={inputParameters.domainName}
        helperText="Without https:// and without www"
        label="Domain name"
        onChange={handleParameterChange("domainName")}
        sx={{ mb: 2 }}
      />
      <FormControl fullWidth variant="outlined">
        <InputLabel htmlFor="outlined-adornment-idx">Resource ID</InputLabel>
        <OutlinedInput
          id="outlined-adornment-idx"
          type={"text"}
          value={inputParameters.idx}
          onChange={handleParameterChange("idx")}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() =>
                  setInputParameters({
                    ...inputParameters,
                    idx: (Math.random() + 1).toString(36).substring(7),
                  })
                }
                onMouseDown={(event) => {
                  event.preventDefault();
                }}
                edge="end"
              >
                <CachedIcon />
              </IconButton>
            </InputAdornment>
          }
          label="Resource ID"
        />
        <FormHelperText id="outlined-adornment-idx">
          5 characters numbers and lowercase letters
        </FormHelperText>
      </FormControl>
    </Fragment>
  );
};

export default parameters;
